import MinigameDucklingTrain from "./MinigameDucklingTrain";

export default class MinigameSwanlingTrain extends MinigameDucklingTrain {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        super.onMinigameStart(game);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        super.onMinigameUpdate(game);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameCancel(game) {
        super.onMinigameCancel(game);
    }
}